import type { PropsWithChildren } from 'react';

import cn from '@/lib/utils/cn';

type Props = PropsWithChildren<{ from: 'user' | 'assistant' }>;

export default function ChatBubble({ from, children }: Props) {
  return (
    <div
      className={cn('text-sm ', {
        'self-end bg-primary-100 max-w-[85%] rounded-2xl rounded-br-none px-3 py-2':
          from === 'user',
        'self-start bg-muted max-w-[85%] rounded-2xl rounded-bl-none px-3 py-2':
          from === 'assistant',
      })}
    >
      {children}
    </div>
  );
}
